import React from 'react';
import {LogOutModalProps} from "../../models";
import {StyledPopUp} from "../../../../shared";
import {Alert, Button, Flex, Modal} from "antd";
import {useNavigate} from "react-router-dom";

const LogOutModal = ({open,onCansel} : LogOutModalProps) => {
    const navigate = useNavigate();

    return (
        <Modal
            open={open}
            onCancel={onCansel}
            title={" "}
            width={"100%"}
            footer={null}
            transitionName={''}
            closable={false}

        >
           <Flex vertical={true} gap={"large"}>
               <Alert
                   message="خروج"
                   description="آیا از خروج از حساب کاربری خود اطمینان دارید ؟"
                   type="warning"
                   showIcon
               />
               <Flex justify={"center"} gap={"large"} align={"center"}>
                   <Button danger block onClick={()  => {
                       localStorage.removeItem("jwt")
                       navigate("/")
                   }}>خروج</Button>
                   <Button block onClick={() => onCansel()}>انصراف</Button>
               </Flex>
           </Flex>
        </Modal>
    );
};

export default LogOutModal;